import moment from "moment";

export const calculateAge=(date)=>{
  if(date) {
    let a = moment();
    let b = moment(date, 'YYYY');
    return a.diff(b, 'years');
  }
  return '';
}

export const getFormattedDate=(date)=>{
  return date ? moment(date).utc().format("DD/MM/YYYY") : ''
}


export const getDeviceId=()=>{
  return "AFC" + Math.floor(Math.random() * ((999 - 100) + 1));
}

export const getLoggedUser=()=>{
  const userData = localStorage.getItem("X-GigyaOnUserData-X");
  if (userData!=null) {
    return JSON.parse(userData);
  } else {
    return null;
  }
}